module.exports = __webpack_public_path__ + "img/12-low.b063198b.jpg";